import { AppBar, Box, IconButton, Toolbar } from "@material-ui/core"
import { Desktop, Mobile, useIsDesktop } from "common/MediaQueries"
import {
  HeaderLinkListDesktop,
  HeaderLinkListMobile,
  NestedNavigationLinksType,
} from "common/SiteLinks"
import NextLink from "common/bit/NextLink"
import Image from "next/image"
import { useState } from "react"
import HamburgerIcon from "reusable/icons/HamburgerIcon"
import XIcon from "reusable/icons/XIcon"
import styled from "styled-components"
import {
  HEADER_ANIME_D,
  HEADER_ANIME_M,
  HEADER_HEIGHT_D,
  HEADER_HEIGHT_M,
  HomePageContainer,
} from "theme/shared"
import HeaderLinkList from "./HeaderLinkList"
import HeaderSubCollapse from "./HeaderSubCollapse"
import HeaderTopButtons from "./HeaderTopButtons"
import SideDrawer from "./sideDrawer/SideDrawer"

const StyledAppBar = styled(AppBar)`
  justify-content: center;
  background-color: ${(p) => p.theme.colors.headerColor};
  transition: transform 330s ease-in-out;
  z-index: 1250 !important;
`
const StyledContainer = styled(HomePageContainer)<{ $narrow: boolean }>`
  height: ${(P) => (P.$narrow ? HEADER_ANIME_M : HEADER_HEIGHT_M)}px;
  transition: height 0.33s linear;
  ${(p) => p.theme.breakpoints.up("md")} {
    height: ${(P) => (P.$narrow ? HEADER_ANIME_D : HEADER_HEIGHT_D)}px;
  }
`
const StyledToolbar = styled(Toolbar).attrs({ disableGutters: true })`
  height: 100%;
  width: 100%;
  justify-content: space-between;
  min-height: auto;
  align-items: center;
  gap: 24px;
  ${(p) => p.theme.breakpoints.down("sm")} {
    flex-direction: row-reverse;
  }
`
const StyledLogoBox = styled(Box)<{ $isNarrow: boolean }>`
  display: flex;
  justify-content: center;
  align-items: center;
  position: relative;
  // on desktop, if $nerrow is true scale logo down with transition similar to header transition
  ${(p) => p.theme.breakpoints.up("md")} {
    transform: ${(P) => (P.$isNarrow ? "scale(0.8)" : "scale(1)")};
    transition: transform 0.33s linear;
  }
`
const IconWrapper = styled(Box)`
  width: 32px;
  height: 32px;
  margin-left: 16px;
`
const StyledMobile = styled(Mobile)`
  width: 100%;
`

const StyledButtonDesktop = styled(Desktop)`
  margin-right: auto;
  flex-shrink: 0;
`

type HeaderProps = {
  narrow?: boolean
  className?: string
  links?: NestedNavigationLinksType[]
  hamburgerLink?: string
  isShopHeader?: boolean
}

const Header = ({
  narrow = false,
  className,
  links,
  isShopHeader = false,
}: HeaderProps) => {
  const isDesktop = useIsDesktop()
  const [isDrawerOpen, setIsDrawerOpen] = useState(false)
  const [subLinks, setSubLinks] = useState(null)

  const toggleDrawer =
    (open: boolean) => (event: React.KeyboardEvent | React.MouseEvent) => {
      console.log("close")
      if (
        event.type === "keydown" &&
        ((event as React.KeyboardEvent).key === "Tab" ||
          (event as React.KeyboardEvent).key === "Shift")
      ) {
        return
      }
      setIsDrawerOpen(open)
    }

  const getLinks = (links, isDesktop) => {
    if (links) return links
    if (isDesktop) return HeaderLinkListDesktop
    return HeaderLinkListMobile
  }

  return (
    <>
      <StyledAppBar className={className}>
        <StyledContainer $narrow={narrow}>
          <StyledToolbar>
            <NextLink href="/">
              <StyledLogoBox $isNarrow={narrow}>
                <Image
                  src="/img/logo-header.png"
                  alt="mazda-logo"
                  width={isDesktop ? 85 : 45}
                  height={isDesktop ? 85 : 45}
                  objectFit="contain"
                  priority
                />
              </StyledLogoBox>
            </NextLink>
            {isShopHeader && (
              <StyledMobile aboveTheFold>
                <HeaderLinkList
                  linkList={getLinks(links, false)}
                  setSubLinks={setSubLinks}
                  isShopHeader={isShopHeader}
                  closeDrawer={() => {
                    setIsDrawerOpen(false)
                  }}
                />
              </StyledMobile>
            )}
            {!isShopHeader && (
              <Mobile aboveTheFold>
                <IconWrapper>
                  <IconButton
                    onClick={toggleDrawer(!isDrawerOpen)}
                    aria-label={
                      isDrawerOpen ? "סגירת תפריט" : "לחץ לפתיחת תפריט ראשי"
                    }
                    color="primary"
                    style={{ padding: 0 }}
                    aria-expanded={isDrawerOpen ? true : false}
                  >
                    {isDrawerOpen ? <XIcon /> : <HamburgerIcon />}
                  </IconButton>
                </IconWrapper>
              </Mobile>
            )}
            <Desktop aboveTheFold>
              <HeaderLinkList
                linkList={getLinks(links, true)}
                setSubLinks={setSubLinks}
                isShopHeader={isShopHeader}
              />
            </Desktop>
            <StyledButtonDesktop aboveTheFold>
              <HeaderTopButtons setSubLinks={setSubLinks} />
            </StyledButtonDesktop>
          </StyledToolbar>
        </StyledContainer>
        <Desktop aboveTheFold>
          <HeaderSubCollapse subLinks={subLinks} />
        </Desktop>
      </StyledAppBar>
      <Mobile>
        <SideDrawer isOpen={isDrawerOpen} toggleDrawer={toggleDrawer} />
      </Mobile>
    </>
  )
}

export default Header
